import AirportTransfer, { airportTransfer } from './airport-transfer';
import ProductModal from './common/components/ProductModal';
import ProductBundle from './ancillary-bundle/containers/ProductBundleContainer';
import AirHelp, { airHelp } from './air-help';
import MutuallyExclusive, { mutuallyExclusive, useMuxCrossStepHide } from './mutually-exclusive';
import CancelForAnyReason, { cancelForAnyReason } from './cancel-for-any-reason';
import BaggageService, { baggageService } from './baggage-service';
import CabinBaggage, { cabinBaggage } from './baggage-section/cabin-baggage';
import CabinUpgrade, { cabinUpgrade } from './cabin-upgrade';
import secondBaggagePerTraveler from './baggage-section/second-baggage';
import CancellationGuarantee, { cancellationGuarantee } from './cancellation-guarantee';
import CancellationInsideEu, { cancellationInsideEu } from './cancellation-inside-eu';
import CancellationOutsideEu, { cancellationOutsideEu } from './cancellation-outside-eu';
import { checkInBaggage, CheckInBaggage, CheckInBaggagePersuasionModal, NotAvailableCheckInBaggage } from './baggage-section/check-in-baggage';
import { climateCompensation, ClimateCompensationNotification } from './climate-compensation';
import CancelTwentyFourHours, { cancelTwentyFourHours } from './cancel-twenty-four-hours';
import FlexibleTicket, { flexibleTicket } from './flexible-ticket';
import TravelInsuranceCoverGenius, { travelInsuranceCoverGenius } from './travel-insurance-cover-genius';
import Meal, { meal } from './meal';
import MobileTravelPlan, { mobileTravelPlan } from './mobile-travel-plan';
import OnlineCheckIn, { onlineCheckIn } from './online-check-in';
import { ancillaryBundle } from './ancillary-bundle';
import { ProductCard, ProductCardBlock, ProductCardList } from './product-card';
import ProductIcon from './common/components/ProductIcon';
import ProductModalHeader from './common/components/ProductModalHeader';
import { SeatMap, SeatMapProductModal, seatMap } from './seat-map';
import SeatMapUnavailable from './seat-map/components/SeatMapUnavailable';
import SeatMapContainer from './seat-map/containers/SeatMapContainer';
import ServicePackage, { servicePackage } from './service-package';
import SingleChoice, { singleChoice } from './single-choice';
import Sms, { sms } from './sms';
import TravelInsuranceInsideEu, { travelInsuranceInsideEu } from './travel-insurance/inside-eu/index';
import TravelInsuranceOutsideEu, { travelInsuranceOutsideEu } from './travel-insurance/outside-eu/index';
import ConnectionGuarantee, { connectionGuarantee } from './connection-guarantee';
import SimpleVisa, { simpleVisa } from './simple-visa';
import Platinum, { platinum } from './platinum';
import SeatMapModalProvider, { useSeatMapModal } from './common/context/SeatMapModalContext';
import Co2Compensation, { co2Compensation } from './co2-compensation';
import EtgFaresContainer, { etgFares } from './etg-fares';
import * as productItems from './products';
import { getProductPictogramId } from './common/utils/icon/getProductImageryIds';
import { getItemCategory2, PRODUCT_BRAND } from './common/utils/productGATrackingUtil';
import BankruptcyInsuranceCoverGenius, { bankruptcyInsuranceCoverGenius } from './bankruptcy-insurance-cover-genius';
import CancellationInsuranceCoverGenius, { cancellationInsuranceCoverGenius } from './cancellation-insurance-cover-genius';
import ComprehensiveInsuranceCoverGenius, { comprehensiveInsuranceCoverGenius } from './comprehensive-insurance-cover-genius';
import FastTrack, { fastTrack } from './fast-track';
import { ProductCardLayoutType } from './common/models/product';
import { SELECTBOX_VALUE } from './common/utils/selectBoxOptions';
import PersonalItem from './baggage-section/personal-item/components/PersonalItem';
import { BAGGAGE_VALUES } from './baggage-section/common/utils/baggageUtils';
import Lounge, { lounge } from './lounge';
import LoungePerSegment, { loungePerSegment } from './lounge-per-segment';
import getTranslatedTexts from './common/text-resolvers/utils/getTranslatedTexts';
import { withParseAvailability } from './common/utils/availability';
import { getPurchasedCartAvailability } from './lounge-per-segment/utils/getPurchasedCartAvailability';
import { withoutNulls } from './airport-transfer/components/utils';
import { loadSessionStateForExtraProducts, saveSessionStateForExtraProducts, removeExtraProductsFromPBSession, getFilteredSelectedProductsId } from './common/utils/postBookingProductsUtils';
const ClimateCompensation = () => null;
const productIds = {
  ...Object.values({
    ...productItems
  }).reduce((acc, val) => ({
    ...acc,
    [val.id]: val.name
  }), {})
};
export { airHelp, AirHelp, airportTransfer, AirportTransfer, ProductBundle, ancillaryBundle, baggageService, BaggageService, bankruptcyInsuranceCoverGenius, BankruptcyInsuranceCoverGenius, cabinBaggage, CabinBaggage, cabinUpgrade, CabinUpgrade, cancelForAnyReason, CancelForAnyReason, cancellationGuarantee, CancellationGuarantee, cancellationInsideEu, CancellationInsideEu, cancellationInsuranceCoverGenius, CancellationInsuranceCoverGenius, cancellationOutsideEu, CancellationOutsideEu, checkInBaggage, CheckInBaggagePersuasionModal, climateCompensation, ClimateCompensation, ClimateCompensationNotification, comprehensiveInsuranceCoverGenius, ComprehensiveInsuranceCoverGenius, connectionGuarantee, ConnectionGuarantee, cancelTwentyFourHours, CancelTwentyFourHours, co2Compensation, Co2Compensation, etgFares, EtgFaresContainer, fastTrack, FastTrack, flexibleTicket, FlexibleTicket, getItemCategory2, getProductPictogramId, meal, Meal, PRODUCT_BRAND, mobileTravelPlan, MobileTravelPlan, mutuallyExclusive, MutuallyExclusive, NotAvailableCheckInBaggage, onlineCheckIn, OnlineCheckIn, lounge, Lounge, loungePerSegment, LoungePerSegment, PersonalItem, Platinum, platinum, ProductCard, ProductCardBlock, ProductCardList, ProductIcon, productIds, productItems, ProductModalHeader, ProductModal, seatMap, SeatMap, SeatMapProductModal, SeatMapModalProvider, SeatMapUnavailable, secondBaggagePerTraveler, servicePackage, ServicePackage, simpleVisa, SimpleVisa, singleChoice, SingleChoice, sms, Sms, travelInsuranceCoverGenius, TravelInsuranceCoverGenius, travelInsuranceInsideEu, TravelInsuranceInsideEu, travelInsuranceOutsideEu, TravelInsuranceOutsideEu, useSeatMapModal };
export const AIR_HELP = {
  ...airHelp,
  component: AirHelp
};
export const BAGGAGE_SERVICE = {
  ...baggageService,
  component: BaggageService
};
export const BANKRUPTCY_INSURANCE_COVER_GENIUS = {
  ...bankruptcyInsuranceCoverGenius,
  component: BankruptcyInsuranceCoverGenius
};
export const CABIN_BAGGAGE = {
  ...cabinBaggage,
  component: CabinBaggage
};
export const CABIN_UPGRADE = {
  ...cabinUpgrade,
  component: CabinUpgrade
};
export const CHECK_IN_BAGGAGE = {
  ...checkInBaggage,
  component: CheckInBaggage
};
export const CANCEL_FOR_ANY_REASON = {
  ...cancelForAnyReason,
  component: CancelForAnyReason
};
export const CANCELLATION_GUARANTEE = {
  ...cancellationGuarantee,
  component: CancellationGuarantee
};
export const CANCELLATION_INSIDE_EU = {
  ...cancellationInsideEu,
  component: CancellationInsideEu
};
export const CANCELLATION_INSURANCE_COVER_GENIUS = {
  ...cancellationInsuranceCoverGenius,
  component: CancellationInsuranceCoverGenius
};
export const CANCELLATION_OUTSIDE_EU = {
  ...cancellationOutsideEu,
  component: CancellationOutsideEu
};
export const COMPREHENSIVE_INSURANCE_COVER_GENIUS = {
  ...comprehensiveInsuranceCoverGenius,
  component: ComprehensiveInsuranceCoverGenius
};
export const CANCEL_24_HOURS = {
  ...cancelTwentyFourHours,
  component: CancelTwentyFourHours
};
export const CO2_COMPENSATION = {
  ...co2Compensation,
  component: Co2Compensation
};
export const MOBILE_TRAVEL_PLAN = {
  ...mobileTravelPlan,
  component: MobileTravelPlan
};
export const ONLINE_CHECK_IN = {
  ...onlineCheckIn,
  component: OnlineCheckIn
};
export const SMS = {
  ...sms,
  component: Sms
};
export const TRAVEL_INSURANCE_COVER_GENIUS = {
  ...travelInsuranceCoverGenius,
  component: TravelInsuranceCoverGenius
};
export const TRAVEL_INSURANCE_INSIDE_EU = {
  ...travelInsuranceInsideEu,
  component: TravelInsuranceInsideEu
};
export const TRAVEL_INSURANCE_OUTSIDE_EU = {
  ...travelInsuranceOutsideEu,
  component: TravelInsuranceOutsideEu
};
export const SIMPLE_VISA = {
  ...simpleVisa,
  component: SimpleVisa
};
export const CLIMATE_COMPENSATION = {
  ...climateCompensation,
  component: ClimateCompensation,
  notificationComponent: ClimateCompensationNotification
};
export const SECOND_BAGGAGE_PER_TRAVELER = {
  ...secondBaggagePerTraveler,
  component: () => null
};
export const MUTUALLY_EXCLUSIVE = {
  ...mutuallyExclusive,
  component: MutuallyExclusive
};
export const FAST_TRACK = {
  ...fastTrack,
  component: FastTrack
};
export const ANCILLARY_BUNDLE = {
  ...ancillaryBundle,
  component: ProductBundle
};
export const FLEXIBLE_TICKET = {
  ...flexibleTicket,
  component: FlexibleTicket
};
export const MEAL = {
  ...meal,
  component: Meal
};
export const PLATINUM_SERVICE = {
  ...platinum,
  component: Platinum
};
export const SEAT_MAP = {
  ...seatMap,
  component: SeatMapContainer
}; // SupportedProduct is defined in client; cross-package type sharing requires this cast

export const LOUNGE = {
  ...lounge,
  component: Lounge
};
export const LOUNGE_PER_SEGMENT = {
  ...loungePerSegment,
  component: LoungePerSegment
};
export const AIRPORT_TRANSFER = {
  ...airportTransfer,
  component: AirportTransfer
};
export const productConstants = {
  AIR_HELP,
  AIRPORT_TRANSFER,
  BAGGAGE_SERVICE,
  BANKRUPTCY_INSURANCE_COVER_GENIUS,
  CABIN_BAGGAGE,
  CABIN_UPGRADE,
  CANCEL_24_HOURS,
  CANCEL_FOR_ANY_REASON,
  CANCELLATION_GUARANTEE,
  CANCELLATION_INSIDE_EU,
  CANCELLATION_INSURANCE_COVER_GENIUS,
  CANCELLATION_OUTSIDE_EU,
  CHECK_IN_BAGGAGE,
  CLIMATE_COMPENSATION,
  COMPREHENSIVE_INSURANCE_COVER_GENIUS,
  CO2_COMPENSATION,
  FAST_TRACK,
  FLEXIBLE_TICKET,
  LOUNGE,
  LOUNGE_PER_SEGMENT,
  MEAL,
  MOBILE_TRAVEL_PLAN,
  ONLINE_CHECK_IN,
  PLATINUM_SERVICE,
  SEAT_MAP,
  SECOND_BAGGAGE_PER_TRAVELER,
  SIMPLE_VISA,
  SMS,
  TRAVEL_INSURANCE_COVER_GENIUS,
  TRAVEL_INSURANCE_INSIDE_EU,
  TRAVEL_INSURANCE_OUTSIDE_EU
};
export { ProductCardLayoutType, withParseAvailability, getPurchasedCartAvailability };
export { SELECTBOX_VALUE, BAGGAGE_VALUES };
export { getTranslatedTexts, withoutNulls };
export { useMuxCrossStepHide };
export { loadSessionStateForExtraProducts, saveSessionStateForExtraProducts, removeExtraProductsFromPBSession, getFilteredSelectedProductsId };
//# sourceMappingURL=index.js.map